import React from "react";
import { Route, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import Loader from "../components/loader";

const toastOptions = {
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

const AccountingPendingRoute = ({ component, ...args }) => {
  const { user } = useAuth0();
  const isAccountingPending = user && user["https://new.evojets.com/appMetadata"]?.isAccountingPending;

  if (isAccountingPending) {
    return (
      <Route
        component={withAuthenticationRequired(component, {
          onRedirecting: () => <Loader/>,
        })}
        {...args}
      />
    );
  }

  toast.error("Unauthorized!", toastOptions);
  return <Redirect to="/"/>;
};

export default AccountingPendingRoute;
